import { contractorApi } from '@/lib/api'

export function downloadContractorInvoice({
  transactionId,
}: {
  transactionId: string
}) {
  return contractorApi.get<BlobPart>(
    `/v1/my/contractor-invoices/transaction/${transactionId}`,
    { responseType: 'blob' },
  )
}
